import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import type { CampaignType } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/constants';
import { CAMPAIGN_TYPES } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/constants';
import type { PlanWizardForm } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/types';
import { DIRTY_VALIDATE } from '~/modules/artist-roster/pages/constants';

import { PlanSection } from '../PlanSection/PlanSection';
import { CampaignTypeRadioButtonGroup } from './components/CampaignTypeRadioButtonGroup';

export function CampaignTypeSection() {
  const { t } = useTranslation('campaign-planner', {
    keyPrefix: 'digitalCampaigns.planWizard.sections.typeOfCampaign',
  });

  const { setValue, watch } = useFormContext<PlanWizardForm>();

  const handleSelect = useCallback(
    (newValue: CampaignType) => {
      setValue('campaignType', newValue, DIRTY_VALIDATE);
    },
    [setValue],
  );

  const campaignType = watch('campaignType');

  return (
    <PlanSection title={t('title')} description={t('description')}>
      <CampaignTypeRadioButtonGroup
        types={Array.from(CAMPAIGN_TYPES)}
        // If we pass undefined here as the initial value React will think the
        // component is uncontrolled. But when we select the first value, the
        // component will become controlled and React throws a warning. So pass
        // a dummy value that isn't one of the campaign types so that nothing
        // is selected by default.
        value={campaignType || ('' as CampaignType)}
        onSelect={handleSelect}
      />
    </PlanSection>
  );
}

CampaignTypeSection.displayName = 'CampaignTypeSection';
